import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import './ForProfessionals.css';

const ForProfessionals = () => {
    return (
        <div className="fp-page">
            <div className="fp-container">

                {/* Hero Section */}
                <section className="fp-hero">
                    <div className="fp-hero-content">

                        <div style={{ marginBottom: '2rem' }}>
                            <Link to="/" style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                                padding: '12px 24px',
                                background: 'rgba(30, 41, 59, 0.6)',
                                color: 'var(--border)',
                                border: '1px solid rgba(71, 85, 105, 0.5)',
                                borderRadius: '50px',
                                cursor: 'pointer',
                                fontSize: '1rem',
                                textDecoration: 'none',
                                backdropFilter: 'blur(8px)',
                                transition: 'all 0.3s'
                            }}
                                onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#818cf8'; e.currentTarget.style.color = '#fff'; }}
                                onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'rgba(71, 85, 105, 0.5)'; e.currentTarget.style.color = 'var(--border)'; }}
                            >
                                <FaArrowLeft /> Back to Home
                            </Link>
                        </div>
                        <h1>Become a <span className="fp-text-accent">Professor of Practice</span> with EdVergenceX</h1>
                        <h2>Bring Your Professional Experience into Higher Education</h2>
                        <p className="fp-lead">
                            Industry and education must work together to prepare students for real-world challenges.
                        </p>
                        <p style={{ fontSize: '1.1rem', color: '#cbd5e1', marginBottom: '2rem' }}>
                            EdVergenceX enables accomplished professionals to contribute to universities and colleges as Professors of Practice (PoPs) — bringing applied knowledge, professional judgment, and industry perspective into academic learning.

                            <br /><br />
                            This pathway allows you to contribute to education without moving into a full-time academic career, while making a meaningful national impact.
                        </p>
                        <div className="fp-cta-group">
                            <Link to="/register" className="fp-btn fp-btn-primary">
                                Express Interest
                            </Link>
                            <a href="#definition" className="fp-btn fp-btn-secondary">
                                Learn More
                            </a>
                        </div>
                    </div>
                </section>

                {/* Definition Section */}
                <section id="definition" className="fp-section">
                    <div className="fp-definition-card">
                        <div className="fp-def-grid">
                            <div>
                                <h2 className="fp-section-title" style={{ textAlign: 'left', marginBottom: '1.5rem' }}>What is a Professor of Practice?</h2>
                                <p style={{ fontSize: '1.1rem', color: '#4b5563', marginBottom: '1.5rem' }}>
                                    A Professor of Practice is a distinguished professional from industry, government, research, entrepreneurship, or the public sector who contributes to higher education by:
                                </p>
                                <div className="fp-def-list">
                                    <ul>
                                        <li>Teaching practice-oriented courses</li>
                                        <li>Guiding applied projects and capstones</li>
                                        <li>Sharing real-world case experience</li>
                                        <li>Mentoring students on professional skills</li>
                                        <li>Supporting curriculum relevance</li>
                                    </ul>
                                </div>
                            </div>
                            <div style={{ background: '#f0fdfa', padding: '2rem', borderRadius: '16px', textAlign: 'center' }}>
                                <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🎓</div>
                                <p style={{ fontWeight: 600, color: '#0f766e', fontSize: '1.2rem' }}>
                                    PoPs strengthen the connection between classroom learning and professional practice.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Benefits Section */}
                <section className="fp-section">
                    <h2 className="fp-section-title">Why Join EdVergenceX as a PoP</h2>
                    <div className="fp-benefits-grid">
                        <div className="fp-benefit-card">
                            <div className="fp-benefit-icon">🌍</div>
                            <h3>Contribute to Nation-Building Through Education</h3>
                            <p>Help shape graduates who are better prepared for the world of work.</p>
                        </div>
                        <div className="fp-benefit-card">
                            <div className="fp-benefit-icon">⏱️</div>
                            <h3>Flexible Engagement</h3>
                            <p>Participate in ways that suit your professional commitments:</p>
                            <ul>
                                <li>Short teaching modules</li>
                                <li>Guest lectures</li>
                                <li>Project or capstone supervision</li>
                                <li>Visiting or adjunct roles</li>
                                <li>Hybrid or remote sessions</li>
                            </ul>
                        </div>
                        <div className="fp-benefit-card">
                            <div className="fp-benefit-icon">🏅</div>
                            <h3>Professional Recognition</h3>
                            <p>Contribute to academia while maintaining your industry role and identity.</p>
                        </div>
                        <div className="fp-benefit-card">
                            <div className="fp-benefit-icon">🛠️</div>
                            <h3>Structured Support</h3>
                            <p>EdVergenceX provides:</p>
                            <ul>
                                <li>Academia-readiness orientation</li>
                                <li>Teaching design assistance</li>
                                <li>Institutional coordination</li>
                                <li>Engagement structure and scheduling</li>
                            </ul>
                            <p style={{ marginTop: '1rem', fontStyle: 'italic' }}>You bring your expertise — we help you deliver it effectively in academic settings.</p>
                        </div>
                    </div>
                </section>

                {/* Eligibility Section */}
                <section className="fp-eligibility">
                    <h2 className="fp-section-title" style={{ color: 'white' }}>Who Can Qualify as a Professor of Practice</h2>
                    <p className="fp-eligibility-sub">Appointments are aligned with national higher education frameworks including UGC, AICTE, NAAC, and NBA expectations.</p>

                    <div className="fp-eligibility-grid">
                        <div>
                            <h3 style={{ fontSize: '1.5rem', marginBottom: '2rem', color: '#2dd4bf' }}>Typical Eligibility Profile</h3>
                            <p style={{ marginBottom: '1.5rem', color: '#cbd5e1' }}>A professional may qualify if they have:</p>

                            <div className="fp-check-list">
                                <div className="fp-check-item">
                                    <span className="fp-check-icon">✓</span>
                                    <span>Significant professional experience (typically 15+ years)</span>
                                </div>
                                <div className="fp-check-item">
                                    <span className="fp-check-icon">✓</span>
                                    <span>Recognized expertise in their field of practice</span>
                                </div>
                                <div className="fp-check-item">
                                    <span className="fp-check-icon">✓</span>
                                    <span>Leadership roles, major projects, innovations, or contributions</span>
                                </div>
                                <div className="fp-check-item">
                                    <span className="fp-check-icon">✓</span>
                                    <span>Industry, government, research, or entrepreneurial background</span>
                                </div>
                                <div className="fp-check-item">
                                    <span className="fp-check-icon">✓</span>
                                    <span>Demonstrated professional achievements</span>
                                </div>
                                <div className="fp-check-item">
                                    <span className="fp-check-icon">✓</span>
                                    <span>Ability to contribute to teaching, mentoring, and applied learning</span>
                                </div>
                            </div>
                        </div>
                        <div className="fp-phd-note">
                            <strong>Note:</strong> A PhD is not mandatory under PoP provisions, as the focus is on professional excellence.
                        </div>
                    </div>
                </section>

                {/* Engagement Steps */}
                <section className="fp-section">
                    <h2 className="fp-section-title">How Engagement Works</h2>
                    <div className="fp-steps">
                        <div className="fp-step-item">
                            <div className="fp-step-number">1</div>
                            <div className="fp-step-content">
                                <h3>Profile Submission</h3>
                                <p>Share your professional experience and areas where you can contribute.</p>
                            </div>
                        </div>
                        <div className="fp-step-item">
                            <div className="fp-step-number">2</div>
                            <div className="fp-step-content">
                                <h3>Orientation & Teaching Readiness Support</h3>
                                <p>EdVergenceX helps translate professional experience into academic engagement.</p>
                            </div>
                        </div>
                        <div className="fp-step-item">
                            <div className="fp-step-number">3</div>
                            <div className="fp-step-content">
                                <h3>Institution Matching</h3>
                                <p>You are connected with institutions seeking practice-led expertise.</p>
                            </div>
                        </div>
                        <div className="fp-step-item">
                            <div className="fp-step-number">4</div>
                            <div className="fp-step-content">
                                <h3>Flexible Academic Roles</h3>
                                <p>You may engage as:</p>
                                <div className="fp-roles-grid">
                                    <div className="fp-role-card">Visiting Professor</div>
                                    <div className="fp-role-card">Adjunct Professor</div>
                                    <div className="fp-role-card">Modular Faculty</div>
                                    <div className="fp-role-card">Capstone Mentor</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Impact Section */}
                <section className="fp-section">
                    <div className="fp-impact-split">
                        <div>
                            <h2 style={{ fontSize: '2rem', fontWeight: 800, color: 'var(--proto-white)', marginBottom: '1.5rem' }}>Your Role in Student Development</h2>
                            <p style={{ marginBottom: '1.5rem', color: '#94a3b8' }}>As a Professor of Practice, you help students:</p>

                            <div className="fp-impact-list">
                                <p><span style={{ color: '#008080' }}>●</span> Understand professional environments</p>
                                <p><span style={{ color: '#008080' }}>●</span> Apply knowledge to real-world contexts</p>
                                <p><span style={{ color: '#008080' }}>●</span> Develop industry-relevant skills</p>
                                <p><span style={{ color: '#008080' }}>●</span> Build professional mindset and readiness</p>
                            </div>
                        </div>
                        <div className="fp-impact-box">
                            <h3>Why This Matters</h3>
                            <p style={{ marginBottom: '1rem', fontSize: '1.1rem' }}>Students need more than theory.</p>
                            <p style={{ marginBottom: '1rem', fontSize: '1.1rem' }}>They need context, judgment, and exposure to real professional practice.</p>
                            <p style={{ fontSize: '1.1rem', fontStyle: 'italic' }}>
                                By contributing as a Professor of Practice, you help transform classrooms into applied learning environments that better prepare learners for the future.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Final CTA */}
                <div className="fp-final-cta">
                    <h2>Join the Professor of Practice Network</h2>
                    <p style={{ fontSize: '1.25rem', color: 'var(--text-muted)', marginBottom: '2rem', maxWidth: '700px', margin: '0 auto 2rem' }}>
                        EdVergenceX brings together experienced professionals and higher education institutions to strengthen practice-led learning.
                    </p>
                    <p style={{ fontSize: '1.1rem', color: 'var(--text-muted)', marginBottom: '3rem' }}>
                        If you are interested in contributing as a Professor of Practice, you are invited to express your interest and share your professional profile.
                    </p>
                    <Link to="/register" className="fp-btn fp-btn-primary" style={{ fontSize: '1.3rem', padding: '20px 48px', borderRadius: '50px' }}>
                        Express Your Interest
                    </Link>
                </div>

            </div>
        </div>
    );
};

export default ForProfessionals;
